import React, { FC } from 'react'
import styled, { useTheme } from 'styled-components'

import { getProjectName } from '../../lib/get-project-name'

export type Props = {
  color: string
  active: boolean
  onClick: () => void
}

export const Color: FC<Props> = ({ active = false, color = 'white', onClick, ...restProps }) => {
  const theme = useTheme()

  return (
    <StyledColor active={active} color={color} onClick={onClick} {...restProps} data-active={active}>
      <Arrow
        xmlns="http://www.w3.org/2000/svg"
        width={theme.spacing[5]}
        height={theme.spacing[5]}
        viewBox="0 0 24 24"
        active={active}
      >
        <Path fillRule="evenodd" d="M18.087 5L8.904 15.142l-2.99-3.326L4 13.888 8.93 19 20 7.073z" />
      </Arrow>
    </StyledColor>
  )
}

const StyledColor = styled.div<Props>`
  position: relative;
  width: ${({ theme }) => (getProjectName() !== 'avito' ? theme.spacing[6] : theme.spacing[7])};
  height: ${({ theme }) => (getProjectName() !== 'avito' ? theme.spacing[6] : theme.spacing[7])};
  box-sizing: border-box;
  display: inline-block;
  vertical-align: middle;
  border-radius: 50%;
  background-color: ${({ color }) => color};

  &:hover {
    cursor: pointer;
  }

  ${({ color }) =>
    (color.toLowerCase() === 'white' || color.toLowerCase() === '#ffffff') && `border: 0.1rem solid #d3d3d3;`}

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 80%;
    height: 80%;
    border-radius: 80%;
    font-size: 0;
    background-color: ${({ theme }) => theme.palette.grey[200]};
    opacity: ${({ active }) => (active ? 1 : 0)};
    transform: translate(-50%, -50%);
    transition: opacity 0.15s;
  }
`

// todo: Убрать стайлед-свг и path
const Arrow = styled.svg<{ active: boolean }>`
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 1;
  width: ${({ theme }) => theme.spacing[5]};
  height: ${({ theme }) => theme.spacing[5]};
  transform: translate(-50%, -50%);
  transition: opacity 0.15s;
  opacity: ${({ active }) => (active ? 1 : 0)};
`

const Path = styled.path`
  fill: ${({ theme }) => theme.palette.brand.primary};
`
